var exports = {
  "M6": "x43aef4ae--7a02ea--slide",
  "r0": "x43aef4ae--7a02ea--slide-inner",
  "k0": "x43aef4ae--7a02ea--slide-image",
};

module.exports = exports;
